export function isJQueryPromise<T>(something: unknown): something is JQueryPromise<T> {
	return typeof something === "object"
		&& "state" in something && typeof something.state === "function"
		&& "always" in something && typeof something.always === "function"
		&& "done" in something && typeof something.done === "function"
		&& "fail" in something && typeof something.fail === "function"
		&& "progress" in something && typeof something.progress === "function"
		&& "pipe" in something && typeof something.pipe === "function"
		&& "promise" in something && typeof something.promise === "function";
}

/**
 * Returns a promise of the provided data that get instantly resolved
 */
export function promiseNow<T>(data?: T): JQueryPromise<T> {
	return $.Deferred<T>().resolve(data).promise();
}

/**
 * Returns a promise with the provided error that immediatly fails
 */
export function promiseFailNow<T>(...error: unknown[]): JQueryPromise<T> {
	return $.Deferred<T>().reject(error).promise();
}

export function toJQueryPromise<T>(jqXHR: JQuery.jqXHR<T>): JQueryPromise<T> {
	const deferred = $.Deferred<T>();
	void jqXHR
		.done((data: T) => deferred.resolve(data))
		.fail((response) => deferred.reject(response));
	return deferred.promise();
}
